<template>
    <div class="categ_info" v-if="obj_to_null(this.cur_item)">

        <div class="redraw_block" v-if="!is_set_data">

            <info_field f_uniq="ct3"
                        f_type="group_name"
                        :is_disabled="true"
                        :f_title="__t('PWA.ACTION_GROUP')"
                        :f_val="active_group_title">
            </info_field>


            <info_field f_uniq="ct1"
                        f_type="title"
                        :is_disabled="false"
                        @update_categ="change_atr"
                        :f_title="__t('NAME')"
                        :f_val="cur_item.title">

            </info_field>

            <info_field f_uniq="ct2"
                        v-if="!is_catalog"
                        f_type="cart_title"
                        :is_disabled="false"
                        @update_categ="change_atr"
                        :f_title="__t('PWA.NAME')"
                        :f_val="cur_item.cart_title">
            </info_field>


            <info_field f_uniq="ct"
                        v-if="!is_catalog"
                        f_type="min_sum"
                        :is_disabled="false"
                        @update_categ="change_atr"
                        :f_title="__t('PWA.MIN_SUM')"
                        :f_val="cur_item.min_sum">
            </info_field>

            <div v-if="is_promo">
                <yes_no
                    key="IS_MULTIPLE"
                    title="IS_MULTIPLE"
                    @input="val => change_atr('is_multiple', val)"
                    v-model="cur_item.is_multiple"
                >
                </yes_no>


            </div>


            <div class="promo_block" v-if="is_promo">
                <div class="simple_promo" v-if="!cur_item.is_multiple">
                    <info_field
                        v-if="active_group.type === 'promo'"
                        f_uniq="ct"
                        f_type="min_sum"
                        :is_disabled="false"
                        @input="val => change_atr('promocode', val)"
                        :f_title="__t('PWA.PROMOCODE')"
                        :f_val="cur_item.promocode">
                    </info_field>
                </div>

                <div v-else>
                    <div class="before_load">

                        <h1 class="display-5 fw-bold mt-3">
                            {{__t('UPLOAD_FILE')}}
                        </h1>

                        <fileload
                            @finish_load="finish_load"
                            :doc_id="cur_item.id"
                            doc_type="action"
                            :url_load="'pos/upload/feed'"
                        ></fileload>
                    </div>
                </div>
            </div>

            <div class="allow_in" >
                <b-row>
                    <b-col>
                        <div>
                            <yes_no
                                key="PUBLISHED"
                                title="PUBLISHED"
                                @input="val => change_atr('published', val)"
                                v-model="cur_item.published"
                            >
                            </yes_no>
                        </div>
                    </b-col>

                    <b-col v-if="!is_delivery && !is_catalog">
                        <div>
                            <yes_no
                                key="IN_DELIVERY"
                                title="IN_DELIVERY"
                                @input="val => change_atr('in_delivery', val)"
                                v-model="cur_item.in_delivery"
                            >
                            </yes_no>
                        </div>
                    </b-col>

                    <b-col v-if="!is_delivery && !is_catalog">
                        <div>
                            <yes_no
                                key="IN_PICKUP"
                                title="IN_PICKUP"
                                @input="val => change_atr('in_pickup', val)"
                                v-model="cur_item.in_pickup"
                            >
                            </yes_no>
                        </div>
                    </b-col>
                </b-row>
            </div>


            <!-- filter by Rest in pwa -->
            <div class="form-group mt-4" v-if="!is_catalog">
                <label class="form-label" for="linked_rest">
                    {{__t("FILTER_RESTAURANTS")}}
                </label>

                <div class="" v-if="restaurants.length > 0">
                    <v-select
                        multiple
                        v-model="action.rest_ids"
                              class="imc_reasons"
                              id="linked_rest"
                              label="title"
                              :reduce="rest => rest.id"
                              :filter="searchRest"
                              :options="restaurants"
                    >
                        <template slot="no-options">
                            {{__t("CHOOSE_POS_REST")}}
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{ option.title }}
                                </div>
                                <div>
                                    <small>
                                        {{option.uniq_id}} {{option.address}}
                                    </small>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>

            <div class="form-group mt-4" v-if="is_catalog">
                <label class="form-label" for="linked_rest">
                    {{__t("FILTER_LOCATIONS")}}
                </label>

                <div class="" v-if="locations.length > 0">
                    <v-select
                        multiple
                        v-model="action.rest_ids"
                        class="imc_reasons"
                        id="linked_rest"
                        label="title"
                        :reduce="rest => rest.id"
                        :filter="searchRest"
                        :options="locations"
                    >
                        <template slot="no-options">
                            {{__t("CHOOSE_POS_REST")}}
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{ option.title }}
                                </div>
                                <div>
                                    <small>
                                        {{option.uniq_id}} {{option.address}}
                                    </small>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import Info_field from "../../../../sys/info_field.vue";

import yes_no from "../../../../sys/radio/yes_no.vue";
import Fuse from 'fuse.js';
import vSelect from 'vue-select';
import Fileload from "../../../../sys/file_loader/fileload.vue";
export default {
    name: "action_info",
    components: {yes_no, Info_field,vSelect,Fileload},
    props : {
        action : {
            type : Object
        }
    },
    created() {
        this.cur_item = this.action;
        this.load_groups();
        this.load_restaurants();
        this.load_locations();
    },


    data() {
        return {
            cur_item : {},
            is_load: false,
            groups : [],
            restaurants : [],
            locations : [],
            is_set_data : false,
            promo_process_files : false,
        }
    },
    methods :  {
        finish_load(file) {
            this.work_promo_file(file);
            EventBus.$emit('reset_files');
        },

        async work_promo_file(file) {

            this.$emit('on_change_attribute','promo_codes',[]);
            await api.post('/internal/v1/catalog/pwa/actions/promo/codes',{
                'file_id' : file.id,
            }).then(({data}) => {
                this.$emit('on_change_attribute','promo_codes',data.data);
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: ['title', 'uniq_id', 'address'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        async load_locations() {
            this.locations = [];
            await agr_api.get('/aggregators/10/locations',).then(({data}) => {
                if (data.status === "operation_success") {
                    this.locations = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async load_restaurants() {
            this.restaurants = [];
            await api.post('/internal/v1/catalog/restaurants', {
                "filter": {

                },
                "list": {
                    "limit": 100
                }
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.restaurants = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async load_groups() {
            this.groups = [];
            this.is_load = true;

            await api.get('/internal/v1/catalog/pwa/actions/groups').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.groups = data.data;

                    this.groups.map(item => {
                        item.is_active = false;
                    })
                } else {
                    this.groups = [];
                }

            }).catch(({response}) => {
                this.is_load = false;
                this.groups = [];
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        change_atr(atr_name,atr_val) {
            this.$emit('on_change_attribute',atr_name,atr_val);
        }
    },
    computed : {

        is_disabled () {
            return this.cur_item.id > 0;
        },

        is_delivery() {
            return this.active_group.type === 'delivery';
        },

        is_catalog() {
            return this.active_group.type === 'catalog';
        },

        is_promo() {
            return this.active_group.type === 'promo';
        },

        active_group_title () {
            return this.__t(this.active_group.title);
        },

        active_group : {
            get :function () {
                let active = {
                    "title" : "unknow",
                    'id' : 0,
                    "type" : "",
                };
                if(this.groups.length > 0) {
                    if(this.action.hasOwnProperty("group_id")) {
                        this.groups.map(item => {
                            if(parseInt(item.id) === parseInt(this.action.group_id)) {
                                active = item;
                            }
                        })
                    }
                }
                return active;
            },

            set: function (val){

            },
        },

    },
}
</script>

<style scoped>

</style>
